import { marquee } from "./marquee";

export function audioPlayer(el, options = {}) {
  const audioEl = el.querySelector('audio');
  const playEl = el.querySelector('.player__play-toggle');
  const durationEl = el.querySelector('.player__duration');
  const currentTimeEl = el.querySelector('.player__current-time');
  const seekEl = el.querySelector('.player__seek');
  const muteEL = el.querySelector('.player__mute');
  const descriptionEl = el.querySelector('.player__description');
  const marqueeEl = options.marquee;
  const skipBackEl = el.querySelector('.player__skip-back');
  const skipForwardEl = el.querySelector('.player__skip-forward');
  const closeEl = el.querySelector('.player__close');
  const radioUrl = el.getAttribute('data-radio-src') || null;
  const radioSite = el.getAttribute('data-radio-site') || null;
  const radioCoId = radioUrl && radioSite === 'radioco' ? radioUrl.split('/').slice(-2, -1) : null;
  const liveBroadcastAnouncementText = el.getAttribute('data-radio-marquee-text') || 'We are live, click here to stream';
  const liveBroadcastPreText = el.getAttribute('data-radio-pre-text') || 'We are live&nbsp;&nbsp;-&nbsp;&nbsp;Now streaming:';
  const liveBroadcastShowCurrent = el.getAttribute('data-radio-show-current') || 'false';
  const upcomingTitle = el.getAttribute('data-radio-upcoming-title');
  let liveState = 'offline';
  let liveCurrentTrack = '';
  let currentTrack = '';
  let playState = 'paused';
  let muteState = 'unmuted';
  let sourceType = '';
  let currentAudio = null;
  let animationFrame = null;

  /*
  player__play-toggle
  player__skip-back
  player__skip-forward
  player__current-time
  player__duration
  player__seek
  player__mute
  player__volume
  */

  playEl.addEventListener('click', togglePlay);

  function togglePlay() {
    if (playState ==='paused') {
      if (audioEl.src === radioUrl) {
        // Resume live playback, rather than previous paused position
        const seekPos = audioEl.duration ? Math.max(0, Math.floor(audioEl.duration) - 10) : 0;
        if (seekPos != Infinity) {
          console.log('Audio element length detected, set seek position normally.');
          audioEl.currentTime = seekPos;
        } else {
          console.log('Audio element length infinite, reset live audio to resume.');
          audioEl.src = '';
          audioEl.load();
          audioEl.src = currentAudio;
        }
      }
      audioEl.play();
      animationFrame = requestAnimationFrame(playingLoop)
      playState = 'playing';
      playEl.setAttribute('playing', '');
      updatePlayButtons(undefined, true);
    } else {
      audioEl.pause();
      cancelAnimationFrame(animationFrame);
      playState = 'paused';
      playEl.removeAttribute('playing');
      updatePlayButtons();
    }
  }

  skipBackEl.addEventListener('click', function() {
    audioEl.currentTime -= 15;
    seekEl.value = Math.floor(audioEl.currentTime);
    currentTimeEl.textContent = setCurrentTime(true);
  });
  
  skipForwardEl.addEventListener('click', function() {
    audioEl.currentTime += 15;
    seekEl.value = Math.floor(audioEl.currentTime);
    currentTimeEl.textContent = setCurrentTime(true);
  });

  muteEL.addEventListener('click', function() {
    if (muteState === 'unmuted') {
      audioEl.muted = true;
      muteState = 'muted';
    } else {
      audioEl.muted = false;
      muteState = 'unmuted';
    }
  });

  function loadProgress(range) {
    if (range === seekEl) {
      el.style.setProperty('--seek-before-width', range.value / range.max * 100 + '%');
    } else {
      el.style.setProperty('--volume-before-width', range.value / range.max * 100 + '%');
    }
  }

  seekEl.addEventListener('input', function(e) {
    loadProgress(e.target);
  });

  function calcTime(secs) {
    const date = new Date(secs * 1000);
    const time = date.toISOString();//.substring(14, 19);
    const days = Number(time.substring(8, 10)) - 1;
    const hours = days > 0 ? days * 24 + Number(time.substring(11, 13)) : Number(time.substring(11, 13));
    const minutes = time.substring(14, 16);
    const seconds = time.substring(17, 19);
    return (hours > 0 ? String(hours) + 'h ' : '') + minutes + 'm ' + seconds + 's';;
  }

  audioEl.addEventListener('durationchange', setDuration);

  function setDuration() {
    const duration = isFinite(audioEl.duration) ? audioEl.duration : 0;
    durationEl.textContent = calcTime(duration);
  }

  function setCurrentTime(timeLeft = true) {
    const current = seekEl.value || 0;
    const total = isFinite(audioEl.duration) ? audioEl.duration : current || 0;
    return timeLeft ? '-' + calcTime(total - current) : calcTime(seekEl.value);
  }

  audioEl.addEventListener('durationchange', setSeekbarMax);

  function setSeekbarMax() {
    seekEl.max = Math.floor(audioEl.duration);
  }

  function displayBuffer() {
    if (audioEl.buffered.length > 0) {
      const buffer = Math.floor(audioEl.buffered.end(audioEl.buffered.length - 1));
      el.style.setProperty('--buffered-width', (buffer / seekEl.max) * 100 + '%');
    }
  }

  function playingLoop() {
    seekEl.value = Math.floor(audioEl.currentTime);
    currentTimeEl.textContent = setCurrentTime(true);
    animationFrame = requestAnimationFrame(playingLoop);
  }

  audioEl.addEventListener('loadedmetadata', function() {
    console.log('loadedmetadata');
    setDuration();
    setSeekbarMax();
    displayBuffer();
  });

  audioEl.addEventListener('progress', displayBuffer);

  seekEl.addEventListener('input', function() {
    currentTimeEl.textContent = setCurrentTime(true);
    if (!audioEl.paused) {
      cancelAnimationFrame(animationFrame);
    }
  });

  seekEl.addEventListener('change', function() {
    audioEl.currentTime = seekEl.value;
    if (!audioEl.paused) {
      requestAnimationFrame(playingLoop);
    }
  });

  function load(url, options = {}) {
    if (url === currentAudio) {
      togglePlay()
      return;
    }

    const description = options.description || '';

    if (url === radioUrl) {
      sourceType = 'live';
      descriptionEl.innerText = liveCurrentTrack;
      // Marquee: update liveCurrentTrack
      console.log('Marquee: update liveCurrentTrack');
      marqueeEl.updateContent(`${liveBroadcastPreText} ${liveBroadcastShowCurrent !== 'false' ? liveCurrentTrack : upcomingTitle}`);
      toggleLivePlayingState('online');
    } else {
      sourceType = 'archive';
      descriptionEl.innerText = description;
      // Marquee: update archived broadcast title
      console.log('Marquee: update archive broadcast title');
      marqueeEl.updateContent(description);
      toggleLivePlayingState('offline');
    }

    audioEl.pause();
    audioEl.src = '';
    playState = 'paused';

    audioEl.load();

    console.log('load new audio');
    currentAudio = url;
    currentTrack = description;
    el.setAttribute('mode', 'player');
    audioEl.src = currentAudio;
    togglePlay();
  }

  audioEl.addEventListener('ended', end);

  closeEl.addEventListener('click', function() {
    playState = 'playing';
    end();
  });

  function end() {
    currentAudio = null;
    sourceType = '';
    togglePlay();
    audioEl.src = '';
    // Marquee: Update end of track, reset to default
    if (liveState === 'online') {
      console.log('Marquee: Update, end of track, back to live announce text');
      marqueeEl.updateContent(liveBroadcastAnouncementText);
    } else {
      console.log('Marquee: Update end of track, reset to default');
      marqueeEl.updateContent();
    }
    el.setAttribute('mode', 'marquee');
    el.removeAttribute('playing-live');
  }

  function createPlayerElements() {
    
  }

  function updatePlayButtons(selector = '.play-audio', create = false) {
    document.querySelectorAll(selector).forEach(function(el) {
      if (el.href === audioEl.src && playState === 'playing') {
        el.toggleAttribute('playing', create);
      } else {
        el.removeAttribute('playing');
      }
    });
  }

  let fetchAttempts = 0;
  if (el.getAttribute('data-radio-site') === 'radioco') {
    getRadiocoLiveStatus(radioCoId);
  } else {
    getGenericLiveStatus(radioUrl);
  }
  
  function getRadiocoLiveStatus(radioId) {
    const url = `https://public.radio.co/stations/${radioId}/status`;
    const promice = fetch(url)
    .then(data => data.json())
    .then(data => {
      const status = data.status;

      if (status === 'online') {
        toggleLiveState('online');
      } else {
        toggleLiveState('offline');
      }

      // Keep current track name updated
      liveCurrentTrack = data.current_track.title || 'Spatial Radio';

      if (sourceType === 'live') {
        descriptionEl.innerText = liveCurrentTrack;
        // Marquee: Update liveCurrentTrack
        console.log('Marquee: Update liveCurrentTrack');
        marqueeEl.updateContent(`${liveBroadcastPreText} ${liveBroadcastShowCurrent !== 'false' ? liveCurrentTrack : upcomingTitle}`);
      }

      console.log('Live radio is ' + status + '. Currently playing: ' + liveCurrentTrack);

      setTimeout(function() {
        getRadiocoLiveStatus(radioCoId);
      }, 15000);
    })
    .catch((error) => { 
      console.log(error);
      fetchAttempts++;
      console.error(`Failed to get Radio.co station status for station with id: ${radioId}. Attempt ${fetchAttempts} of 3.`);
      if (fetchAttempts < 3) {
        // Try up to 3 attempts on each session
        setTimeout(function() {

          getRadiocoLiveStatus(radioCoId);
        }, 15000);
      }
    });
  }

  function getGenericLiveStatus(url) {
    if (!url) {
      console.info('No radio url');
      return;
    }
    const promice = fetch(url)
    .then(data => {
      console.log('---');
      console.log(data);
      console.log('---');

      toggleLiveState('online');

      // Keep current track name updated
      liveCurrentTrack = 'Spatial Radio';

      if (sourceType === 'live') {
        descriptionEl.innerText = liveCurrentTrack;
        // Marquee: Update liveCurrentTrack
        console.log('Marquee: Update liveCurrentTrack');
        marqueeEl.updateContent(liveBroadcastPreText + (liveBroadcastShowCurrent !== 'false' ? ' ' + liveCurrentTrack : ''));
      }

      console.log('Live radio is online. Currently playing: ' + liveCurrentTrack);

      setTimeout(function() {
        getGenericLiveStatus(url);
      }, 15000);

    })
    .catch((error) => {
      console.log(error);
      fetchAttempts++;
      console.error(`Failed to get livestream with url: ${url}. Attempt ${fetchAttempts} of 3.`);
      toggleLiveState('offline');
      if (fetchAttempts < 3) {
        setTimeout(function() {
          getGenericLiveStatus(url);
        }, 15000);
      }
    });
  }

  function toggleLiveState(state) {
    if (state === 'online' && liveState !== 'online') {
      liveState = 'online';
      document.body.setAttribute('radio-live', '')
      // Marquee: Update liveBroadcastAnnouncementText
      console.log('Marquee: Update, liveBroadcastAnnoucementText into marquee');
      marqueeEl.updateContent(liveBroadcastAnouncementText);
    } else if (state === 'offline' && liveState !== 'offline') {
      liveState = 'offline';
      document.body.removeAttribute('radio-live');
      // Marquee: Update back to default
      console.log('Marquee: Update, liveState now offline, reset to defaukt');
      marqueeEl.updateContent();
    } else {
      console.log('toggleLiveState: Already set, dont toggle.');
    }
  }

  function toggleLivePlayingState(state) {
    el.toggleAttribute('playing-live', state === 'online')
  }

  return {
    load,
    updatePlayButtons,
  }
}

export function playButton(el, player, stream = false) {
  const url = el.href;
  const title = el.getAttribute('title') || '';
  const description = el.getAttribute('data-description') || null;
  el.addEventListener('click', function(e) {
    e.preventDefault();
    player.load(url, {
      description: title,
    });
  });
}




// window.setInterval(checkStreamStatus, 5000);
// function checkStreamStatus() {
//   console.log('Checking stream status...');
// }
